import { CheckIcon } from "@chakra-ui/icons";
import {
    Box,
    Heading,
    HStack,
    Icon,
    RadioGroup,
    Text,
    VStack
} from "@chakra-ui/react";

const PaymentOptions = ({ totalAmount, selectedPlan, setSelectedPlan }) => {


    const getPaymentDetails = (plan) => {
        let today = new Date();
        let nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);

        let twoMonthsLater = new Date(today);
        twoMonthsLater.setMonth(today.getMonth() + 2);

        let formatDate = (date) =>
            date.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });

        if (plan === "full") {
            return [{ amount: totalAmount, dueDate: "Today" }];
        } else if (plan === "2-pay") {
            let firstPayment = Math.ceil(totalAmount / 2);
            let secondPayment = totalAmount - firstPayment;
            return [
                { amount: firstPayment, dueDate: "Today" },
                { amount: secondPayment, dueDate: formatDate(nextMonth) },
            ];
        } else {
            let installment = Math.floor(totalAmount / 3);
            let firstPayment = totalAmount - installment * 2;
            return [
                { amount: firstPayment, dueDate: "Today" },
                { amount: installment, dueDate: formatDate(nextMonth) },
                { amount: installment, dueDate: formatDate(twoMonthsLater) },
            ];
        }
    };

    return (
        <Box>
            <Heading size="md" mb={4}>Select Payment Plan</Heading>


            <RadioGroup onChange={setSelectedPlan} value={selectedPlan}>
                <HStack spacing={4} align="stretch">
                    {["full", "2-pay", "3-pay"].map((plan) => (
                        <Box
                            key={plan}
                            p={4}
                            borderWidth="2px"
                            borderRadius="md"
                            cursor={totalAmount >= 20 || plan === "full" ? "pointer" : "not-allowed"}
                            transition="0.3s"
                            borderColor={
                                totalAmount >= 20 || plan === "full"
                                    ? selectedPlan === plan
                                        ? "blue.900"
                                        : "gray.300"
                                    : "gray.200"
                            }
                            bg={
                                totalAmount >= 20 || plan === "full"
                                    ? selectedPlan === plan
                                        ? "blue.900"
                                        : "white"
                                    : "gray.100"
                            }
                            color={selectedPlan === plan ? "#f4b31b" : "gray.700"}
                            onClick={() => totalAmount >= 20 || plan === "full" ? setSelectedPlan(plan) : null}
                            w="33%"
                            textAlign="center"
                            opacity={totalAmount >= 20 || plan === "full" ? 1 : 0.5} // Gray out when disabled
                        >
                            <HStack justify="center" spacing={2}>
                                {selectedPlan === plan && <Icon as={CheckIcon} boxSize={5} color="#f4b31b" />}
                                <Text fontWeight="bold">
                                    {plan === "full"
                                        ? "Pay in Full"
                                        : plan === "2-pay"
                                            ? "2 Payments"
                                            : "3 Payments"}
                                </Text>
                            </HStack>
                            {/* Payment Breakdown (Only Show for Enabled Options) */}
                            {totalAmount >= 20 || plan === "full" ? (
                                <VStack align="center" mt={2} fontSize="sm">
                                    {getPaymentDetails(plan).map((payment, index) => (
                                        <Text key={index}>
                                            {index === 0 ? "First Charge" : `Next Charge #${index + 1}`}:
                                            <b> ${Number(payment.amount).toFixed(2)}</b> ({payment.dueDate})
                                        </Text>
                                    ))}
                                </VStack>
                            ) : <Text fontSize="sm" color="red.500" mt={2} textAlign="center">
                                This amount is not eligible for multi-payment options.
                            </Text>}
                        </Box>
                    ))}
                </HStack>


            </RadioGroup>



        </Box>
    );
};

export default PaymentOptions;
